import moment from "moment/moment";
import { Accordion, AccordionTab } from "primereact/accordion";
import { InputTextarea } from "primereact/inputtextarea";
import { ProgressBar } from "primereact/progressbar";
import { TabPanel } from "primereact/tabview";
import { classNames } from "primereact/utils";
import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import { useNavigate, useParams } from "react-router-dom";
import Encuesta1 from "../../assets/img/Encuesta1.svg";
import Encuesta2 from "../../assets/img/Encuesta2.svg";
import Encuesta3 from "../../assets/img/Encuesta3.svg";
import Encuesta4 from "../../assets/img/Encuesta4.svg";
import Encuesta5 from "../../assets/img/Encuesta5.svg";
import iconDownload from "../../assets/img/interna/download.png";
import ButtonZegel from "../../components/Buttons/ButtonZegel";
import ChatTennet from "../../components/Chat/ChatTennetV2";
import DialogZegel from "../../components/Dialog/DialogZegel";
import FooterInterno from "../../components/Footer/FooterInterno";
import DashboardNavBar from "../../components/Header/DashboardNavBar";
import TabZal from "../../components/TabZal/TabZal";
import { formatTimefromSeconds, timeToSeconds } from "../../helpers/helpers";
import useAlumno from "../../hooks/useAlumno";
import { PrivateRoutes } from "../../routes/routes";
import { ListarBibliotecasPorCurso } from "../../services/BibliotecaServices";
import {
  ActualizarEncuestaPersonaCurso,
  BuscarCursoID,
  ObtenerEncuestaPersonaCurso,
  RegistrarEncuestaPersonaCurso,
} from "../../services/CursoService";
import { ObtenerEvaluacionesPersonaCurso } from "../../services/EvaluacionService";
import { ListarLeccionesPorCurso } from "../../services/LeccionServices";
import { ListarMaterialesCurso } from "../../services/MaterialService";
import {
  ActualizarProgresoCurso,
  ObtenerProgresoCursoPorPersonaCurso,
  RegistrarProgresoCurso,
} from "../../services/ProgresoService";
import { ListarUnidadesPorCurso } from "../../services/UnidadService";
import { ObtenerCursoUsuarioPorId } from "../../services/UsuarioService";
import EvaluacionDashboard from "./EvaluacionDashboard";
import "./styles/CursoInterno.scss";
import zegel from "../../assets/img/zegel.png";
import { Dialog } from "primereact/dialog";

const CursoInterno = () => {

  const [visible, setVisible] = useState(false);
  const aboutSection = useRef(null);
  let { idCursoUsuario } = useParams();
  let { idUnidad } = useParams();
  let { IDLeccion } = useParams();
  const navigate = useNavigate();
  const { perfil, configuraciones } = useAlumno();
  const [curso, setCurso] = useState(null);
  const [cursoUsuario, setCursoUsuario] = useState(null);
  const [listaUnidades, setListaUnidades] = useState(null);
  const [listaLeccionesUnidad, setlistaLeccionesUnidad] = useState();
  const [listaLecciones, setListaLecciones] = useState(null);
  const [listaMateriales, setListaMateriales] = useState(null);
  const [materialesLeccion, setMaterialesLeccion] = useState(null);
  const [leccionSeleccionada, setLeccionSeleccionada] = useState({
    idLeccion: 0,
  });

  const [unidadSeleccionada, setUnidadSeleccionada] = useState(null);
  const [indexTab, setIndexTab] = useState(-1);

  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const [progresoBar, setProgresoBar] = useState(0);
  const [evaluacionesProgreso, setEvaluacionesProgreso] = useState(0);

  const [progresoCurso, setProgresoCurso] = useState(null);
  const [progresoLeccionSeleccionado, setProgresoLeccionSeleccionado] =
    useState(null);

  const [bibliografiaCurso, setBibliografiaCurso] = useState(null);

  const [evaluacionSeleccionada, setEvaluacionSeleccionada] = useState(null);

  /*Encuestas*/
  const [showAlertEncuestaCurso, setShowAlertEncuestaCurso] = useState(null);

  const [contenidoEncuestaCurso, setContenidoEncuestaCurso] = useState(null);

  const [showAlertValoracionPlataforma, setShowAlertValoracionPlataforma] =
    useState(false);
  const [selectedButtonEncuetas1, setSelectedButtonEncuetas1] = useState(null);
  const [textareaEncuesta1Value, settextareaEncuesta1Value] = useState("");
  const [BtonDisableEncuesta1, setBtonDisableEncuesta1] = useState(true);
  const [NumeradorPantallaDialogAbierta, setNumeradorPantallaDialogAbierta] =
    useState(0);
  const [showAlertRecomendacionCurso, setshowAlertRecomendacionCurso] =
    useState(false);
  const [selectedButtonEncuesta4, setSelectedButtonEncuesta4] = useState(null);
  const [BtonDisableEncuesta4, setBtonDisableEncuesta4] = useState(true);
  const [
    showAlertRecomendacionCursoDialog5,
    setshowAlertRecomendacionCursoDialog5,
  ] = useState(false);
  const [selectedButtonEncuetas5, setSelectedButtonEncuetas5] = useState(null);
  const [textareaEncuesta5Value, settextareaEncuesta5Value] = useState("");
  const [selectedButtonEncuetas6, setSelectedButtonEncuetas6] = useState(null);
  const [textareaEncuesta6Value, settextareaEncuesta6Value] = useState("");
  const [
    showAlertRecomendacionCursoDialog6,
    setshowAlertRecomendacionCursoDialog6,
  ] = useState(false);
  const [BtonDisableEncuesta6, setBtonDisableEncuesta6] = useState(true);

  const [evaluacionesUnidad, setEvaluacionesUnidad] = useState(null);
  const [disabledCurso, setDisabledCurso] = useState(false);
  const [cursoExpiradoAmpliacion, setCursoExpiradoAmpliacion] = useState(false);
  const [cursoExpiradoMembresia, setCursoExpiradoMembresia] = useState(false);

  //testing
  const findIndexById = (id) => {
    return listaUnidades.findIndex((item) => item.idUnidad === id);
  };

  useEffect(() => {
    if (IDLeccion && listaMateriales && listaLecciones) {      
      let temp = listaLecciones.find(
        (x) => x.idLeccion === parseInt(IDLeccion)
      );
      if (temp) {
        setLeccionSeleccionada(temp);
      }
    }
    if (IDLeccion===undefined && listaMateriales && listaLecciones) {
      setLeccionSeleccionada(listaLecciones.filter(x=>x.idUnidad == listaUnidades[0]?.idUnidad)[0]);
    }
  }, [IDLeccion, listaMateriales, listaLecciones]);

  useEffect(() => {
    const GetCursoUsuario = () => {
      let jwt = window.localStorage.getItem("jwt");
      let id = idCursoUsuario;

      ObtenerCursoUsuarioPorId({ jwt, id }).then((data) => {
        setCursoUsuario(data);
        if (data && data.idUsuario !== perfil.idUsuario) {
          navigate("/" + PrivateRoutes.HOME + "/Dashboard");
          return;
        }

        if (!data) {
          navigate("/" + PrivateRoutes.HOME + "/Dashboard");
          return;
        }
        // if (data.bienvenida === false) {
        //   navigate(
        //     "/" + PrivateRoutes.HOME + "/CursoInterno/" + data.idPersonaCurso
        //   );
        // }
      });
    };
    if (perfil && idCursoUsuario) {
      GetCursoUsuario();
    }
  }, [idCursoUsuario, perfil]);

  useEffect(() => {
    const getEvaluacion = () => {
      let jwt = window.localStorage.getItem("jwt");
      let id = idCursoUsuario;
      ObtenerEvaluacionesPersonaCurso({ jwt, id }).then((data) => {
        setEvaluacionesUnidad(data);
      });
    };
    if (idCursoUsuario) getEvaluacion();
  }, [idCursoUsuario]);

  useEffect(() => {
    if (cursoUsuario) {
      if (cursoUsuario) {
        let fechaActual = new Date();
        if (
          new Date(cursoUsuario.fechaVigencia) < fechaActual 
        ) {
          if (cursoUsuario.fechaAmpliacionCurso) {
            if (new Date(cursoUsuario.fechaAmpliacionCurso) < new Date()) {
              setCursoExpiradoAmpliacion(true);
            }
          }
          setDisabledCurso(true);
        }
        if (cursoUsuario.fechaVigenciaMembresia) {
          if (new Date(cursoUsuario.fechaVigenciaMembresia) < new Date()) {
            setCursoExpiradoMembresia(true);
            setDisabledCurso(true);
          }
        }

        if (cursoUsuario.idEstado == 3) {
          navigate("/" + PrivateRoutes.HOME + "/Dashboard");
        }
      }
    }
  }, [cursoUsuario]);
  useEffect(() => {
    const GetCurso = () => {
      let jwt = window.localStorage.getItem("jwt");
      let idCurso = cursoUsuario.idCurso;
      BuscarCursoID({ jwt, idCurso }).then((data) => {
        setCurso(data);
      });
    };
    if (cursoUsuario) GetCurso();
  }, [cursoUsuario]);

  useEffect(() => {
    const getUnidades = () => {
      let jwt = window.localStorage.getItem("jwt");
      let idCurso = curso.idCurso;
      ListarUnidadesPorCurso({ jwt, idCurso }).then((data) => {
        function compararPorSecuencia(a, b) {
          return a.secuencia - b.secuencia;
        }
        let arrayOrdenado = data.slice();
        arrayOrdenado.sort(compararPorSecuencia);
        setListaUnidades(arrayOrdenado);
      });
    };
    if (curso) getUnidades();
  }, [curso]);

  useEffect(() => {
    const getLeccionesCursos = () => {
      let jwt = window.localStorage.getItem("jwt");
      let idCurso = curso.idCurso;
      ListarLeccionesPorCurso({ jwt, idCurso }).then((data) => {

        function compararPorSecuencia(a, b) {
          return a.secuencia - b.secuencia;
        }
        let leccionesOrdenado = data.slice();
        leccionesOrdenado.sort(compararPorSecuencia);
        setListaLecciones(leccionesOrdenado);
      });
    };
    if (curso) getLeccionesCursos();
  }, [curso]);

  useEffect(() => {
    const getMaterial = () => {
      let jwt = window.localStorage.getItem("jwt");
      let idCurso = curso.idCurso;
      ListarMaterialesCurso({ jwt, idCurso }).then((data) => {
        setListaMateriales(data);
      });
    };
    if (curso) getMaterial();
  }, [curso]);

  useEffect(() => {
    const getBibliografia = () => {
      let jwt = window.localStorage.getItem("jwt");
      let idCurso = curso.idCurso;
      ListarBibliotecasPorCurso({ jwt, idCurso }).then((data) => {
        setBibliografiaCurso(data);
      });
    };
    if (curso) getBibliografia();
  }, [curso]);

  const getProgresoCurso = () => {
    let jwt = window.localStorage.getItem("jwt");
    let idPersonaCurso = idCursoUsuario;
    ObtenerProgresoCursoPorPersonaCurso({ jwt, idPersonaCurso }).then(
      (data) => {
        setProgresoCurso(data);
      }
    );
  };

  useEffect(() => {
    if (listaLecciones) {
      getProgresoCurso();
    }
  }, [listaLecciones]);

  useEffect(() => {
    let porcentajeEva = 0;
    if (listaUnidades && idCursoUsuario) {
      let jwt = window.localStorage.getItem("jwt");
      let id = idCursoUsuario;

      ObtenerEvaluacionesPersonaCurso({ jwt, id }).then((data) => {
        if (data && data.length > 0) {
          let dataTemp = data.filter((x) => x.intento == 1);
          if (dataTemp.length > 0) {
            let numUnidades = listaUnidades.length;
            let numEvaRealizadas = dataTemp.length;

            porcentajeEva = (numEvaRealizadas / numUnidades) * 100;
            setEvaluacionesProgreso(porcentajeEva * 0.5);
          }
        }
      });
    }
  }, [listaUnidades, idCursoUsuario]);

  useEffect(() => {
    if (progresoCurso) {
      const porcentajes = listaLecciones.map((leccion) => {
        const tiempo = progresoCurso.find(
          (tiempo) => tiempo.idLeccion === leccion.idLeccion
        );
        if (tiempo) {
          let tiempoa = moment(tiempo.tiempoVideoActual).format("HH:mm:ss");
          let tiempot = moment(tiempo.tiempoVideoTotal).format("HH:mm:ss");

          return ((timeToSeconds(tiempoa)) / timeToSeconds(tiempot)) * 100;
        } else {
          return 0; // Si no se encuentra el tiempo, consideramos el porcentaje como 0
        }
      });

      const promedioPorcentajes =
        porcentajes.reduce((total, porcentaje) => total + porcentaje, 0) /
        porcentajes.length;
      setProgresoBar(promedioPorcentajes * 0.5);
      let jwt = window.localStorage.getItem("jwt");
      let idPersonaCurso = idCursoUsuario;
      if (
        promedioPorcentajes * 0.5 + evaluacionesProgreso >= 50 &&
        promedioPorcentajes * 0.5 + evaluacionesProgreso < 100
      ) {

        ObtenerEncuestaPersonaCurso({ jwt, idPersonaCurso }).then((data) => {
          if (data.length > 0) {
            if (data[0].primerEncuestaCursoRealizada != true) {
               setShowAlertEncuestaCurso(true);
               setContenidoEncuestaCurso(encuestaCurso);
              setNumeradorPantallaDialogAbierta(1);
            }
          } else {
            setShowAlertEncuestaCurso(true);
            setContenidoEncuestaCurso(encuestaCurso);
            setNumeradorPantallaDialogAbierta(1);
          }
        });
      }
      if (evaluacionesProgreso >= Math.ceil(50)) { /* que solo realice las evaluacion sin ver todos los videos en su totalidad */
        ObtenerEncuestaPersonaCurso({ jwt, idPersonaCurso }).then((data) => {
          if (data.length > 0) {
            if (data[0].segundaEncuestaCursoRealizada != true) {
              if (cursoUsuario.idCondicion == 1) {
                setShowAlertEncuestaCurso(true);
                setContenidoEncuestaCurso(encuestaCursoFinalizado);
                setNumeradorPantallaDialogAbierta(3);
              }
            }
          }
        });
      }
    }
  }, [progresoCurso]);

  useEffect(() => {
    if (leccionSeleccionada.idLeccion > 0) {
      if (listaMateriales) {
        let temp = listaMateriales.filter(
          (x) => x.idLeccion == leccionSeleccionada.idLeccion
        );
        setMaterialesLeccion(temp);
      }
    } else {
      setMaterialesLeccion(null);
    }
  }, [leccionSeleccionada]);

  const handlePause = () => {
    guardarProgreso(leccionSeleccionada.idLeccion);
    window.localStorage.removeItem(
      `video_${idCursoUsuario}_${leccionSeleccionada.idLeccion}`
    );
  };
  const handleProgress = (progress) => {
    setCurrentTime(progress.playedSeconds);
  };

  const handleDuration = (duration) => {
    setDuration(duration);
  };

  useEffect(() => {
    if (duration > 0 && currentTime > 0) {
      let detalle = `${idCursoUsuario},${leccionSeleccionada.idLeccion
        },${duration},${Math.round(currentTime)}`;
      if (progresoCurso) {
        if (progresoLeccionSeleccionado) {
          let segundosBD = timeToSeconds(
            moment(progresoLeccionSeleccionado.tiempoVideoActual).format(
              "HH:mm:ss"
            )
          );
          // let totalBD = timeToSeconds(
          //   moment(progresoLeccionSeleccionado.tiempoVideoTotal).format(
          //     "HH:mm:ss"
          //   )
          // );
          if (segundosBD < Math.round(currentTime)) {
            localStorage.setItem(
              `video_${idCursoUsuario}_${leccionSeleccionada.idLeccion}`,
              detalle
            );
          }
          //guardamos si completa el video
          if (duration == Math.round(currentTime)) {
            if (segundosBD < Math.round(currentTime)) {
              guardarProgreso(leccionSeleccionada.idLeccion);
            }
          }
        } else {
          localStorage.setItem(
            `video_${idCursoUsuario}_${leccionSeleccionada.idLeccion}`,
            detalle
          );
        }
      } else {
        localStorage.setItem(
          `video_${idCursoUsuario}_${leccionSeleccionada.idLeccion}`,
          detalle
        );
      }
    }
  }, [duration, currentTime]);

  const registraProgreso = (IDleccion) => {
    let jwt = window.localStorage.getItem("jwt");

    let videoLocalStorage = window.localStorage.getItem(
      `video_${idCursoUsuario}_${IDleccion}`
    );
    if (Boolean(videoLocalStorage)) {
      let arrayVideo = videoLocalStorage.split(",");

      let idProgresoCurso = 0;
      let idPersonaCurso = idCursoUsuario;
      let idLeccion = IDleccion;
      let tiempoVideoActual = obtenerDateVideo(arrayVideo[3]);
      let tiempoVideoTotal = obtenerDateVideo(arrayVideo[2]);
      let jsonProgreso = JSON.stringify(
        {
          idProgresoCurso,
          idPersonaCurso,
          idLeccion,
          tiempoVideoActual,
          tiempoVideoTotal,
        },
        null,
        2
      );
      RegistrarProgresoCurso({ jwt, jsonProgreso }).then((data) => {
        window.localStorage.removeItem(`video_${idCursoUsuario}_${IDleccion}`);
        getProgresoCurso();
      });
    }
  };

  const actualizarProgreso = (idProgreso, IDleccion) => {
    let jwt = window.localStorage.getItem("jwt");

    let videoLocalStorage = window.localStorage.getItem(
      `video_${idCursoUsuario}_${IDleccion}`
    );
    if (Boolean(videoLocalStorage)) {
      let idProgresoCurso = idProgreso;
      let idPersonaCurso = idCursoUsuario;
      let idLeccion = leccionSeleccionada.idLeccion;
      let tiempoVideoActual = obtenerDateVideo(Math.round(currentTime));
      let tiempoVideoTotal = obtenerDateVideo(duration);
      let jsonProgreso = JSON.stringify(
        {
          idProgresoCurso,
          idPersonaCurso,
          idLeccion,
          tiempoVideoActual,
          tiempoVideoTotal,
        },
        null,
        2
      );
      ActualizarProgresoCurso({ jwt, jsonProgreso }).then((data) => {
        window.localStorage.removeItem(`video_${idCursoUsuario}_${IDleccion}`);
        getProgresoCurso();
      });
    }
  };
  const obtenerDateVideo = (tiempo) => {
    const formattedDate = moment().format("YYYY-MM-DD");
    const dateTimeString = `${formattedDate} ${formatTimefromSeconds(tiempo)}`;
    const dateTimeObject = new Date(dateTimeString);
    return dateTimeString;
  };
  const valueTemplate = (value) => {
    return (
      <React.Fragment>
        <span></span>
      </React.Fragment>
    );
  };
  const tabUnidadTemplate = (item, descripcion) => {
    return (
      <div className="p-accordion-header-text">
        <div className="text-xs font-bold mb-2">Unidad {item}</div>
        <div className="text-xs font-normal">{descripcion}</div>
      </div>
    );
  };
  const guardarProgreso = (IDLeccion) => {
    if (currentTime > 0 && IDLeccion > 0) {
      if (progresoCurso) {
        let p_leccion = progresoCurso.find((x) => x.idLeccion == IDLeccion);
        if (p_leccion) {
          actualizarProgreso(p_leccion.idProgresoCurso, IDLeccion);
        } else {
          registraProgreso(IDLeccion);
        }
      } else {
        registraProgreso(IDLeccion);
      }
    }
  };

  const EstadoLeccion = (id) => {
    const temp = progresoCurso.find((x) => x.idLeccion === id);
    if (temp) {
      let actual = moment(temp.tiempoVideoActual).format("HH:mm:ss");
      let total = moment(temp.tiempoVideoTotal).format("HH:mm:ss");
      if (timeToSeconds(total) - timeToSeconds(actual) > 15) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  function EncuestaValidarCurso() {
    if (NumeradorPantallaDialogAbierta == 3) {
      setshowAlertRecomendacionCurso(true);
      setShowAlertEncuestaCurso(true);
      setNumeradorPantallaDialogAbierta(4);
    }
    if (NumeradorPantallaDialogAbierta == 1) {
      setShowAlertValoracionPlataforma(true);
      setShowAlertEncuestaCurso(true);
      setNumeradorPantallaDialogAbierta(2);
    }
  }

  const footerEncuestaCurso = (
    <>
      <div style={{ marginBottom: 8 }}>
        <ButtonZegel
          label= {cursoUsuario && cursoUsuario.idPrograma > 0
            ? "Valorar módulo" 
            :"Valorar curso" }
          color="primary"
          onClick={() => EncuestaValidarCurso()}
        ></ButtonZegel>
      </div>
    </>
  );


  const enviarEncuesta1 = () => {

    //setSelectedButtonEncuetas1(buttonIndex);
    let IdPersonaCurso = idCursoUsuario;
    let PrimerEncuestaCursoRealizada = true;
    let PrimerEncuestaCursoResultado = selectedButtonEncuetas1;
    let PrimerEncuestaCursoComentario = textareaEncuesta1Value;
    let encuestaCurso = JSON.stringify({
      IdPersonaCurso,
      PrimerEncuestaCursoRealizada,
      PrimerEncuestaCursoResultado,
      PrimerEncuestaCursoComentario,
    });
    let jwt = window.localStorage.getItem("jwt");
    RegistrarEncuestaPersonaCurso({ encuestaCurso, jwt }).then((data) => {
      setShowAlertValoracionPlataforma(false);
    });
  };

  const enviarEncuesta2 = () => {
 
    if (NumeradorPantallaDialogAbierta == 6) {

      let IdPersonaCurso = idCursoUsuario;
      let SegundaEncuestaCursoRealizada = true;
      let SegundaEncuestaCursoResultado1 = selectedButtonEncuesta4;
      let SegundaEncuestaCursoResultado2 = selectedButtonEncuetas5;
      let SegundaEncuestaCursoComentarioResultado2 = textareaEncuesta5Value;
      let SegundaEncuestaCursoResultado3 = selectedButtonEncuetas6;
      let SegundaEncuestaCursoComentarioResultado3 = textareaEncuesta6Value;
      let jwt = window.localStorage.getItem("jwt");

      let encuestaCurso = JSON.stringify({
        IdPersonaCurso,
        SegundaEncuestaCursoRealizada,
        SegundaEncuestaCursoResultado1,
        SegundaEncuestaCursoResultado2,
        SegundaEncuestaCursoComentarioResultado2,
        SegundaEncuestaCursoResultado3,
        SegundaEncuestaCursoComentarioResultado3,
      });
      ActualizarEncuestaPersonaCurso({ encuestaCurso, jwt }).then((data) => {
        setNumeradorPantallaDialogAbierta(0);
        setshowAlertRecomendacionCursoDialog6(false);
        (cursoUsuario.idPersonaPrograma && cursoUsuario.idPersonaPrograma!= null)?
        navigate("/" + PrivateRoutes.HOME + "/ProgresoPrograma/"+cursoUsuario.idPrograma+"/"+cursoUsuario.idPersonaPrograma+"/" + curso.idCurso):
        navigate("/" + PrivateRoutes.HOME + "/ProgresoCurso/" + curso.idCurso);
      });
    }

    if (NumeradorPantallaDialogAbierta == 5) {
      setNumeradorPantallaDialogAbierta(6);
      setshowAlertRecomendacionCursoDialog5(false);
      setBtonDisableEncuesta4(true);
      setshowAlertRecomendacionCursoDialog6(true);
    }
    if (NumeradorPantallaDialogAbierta == 4) {
      setshowAlertRecomendacionCurso(false);
      setshowAlertRecomendacionCursoDialog5(true);
      setBtonDisableEncuesta4(true);
      setNumeradorPantallaDialogAbierta(5);
    }
  };

  const footerValoracionPlataforma = (
    <>
      <div style={{ marginBottom: 8 }}>
        <ButtonZegel
          disabled={BtonDisableEncuesta1}
          label="Enviar"
          color="primary"
          onClick={() => {
            enviarEncuesta1();
          }}
        ></ButtonZegel>
      </div>
    </>
  );

  const footerRecomendacionPlataforma = (
    <>
      <div style={{ marginBottom: 8 }}>
        <ButtonZegel
          disabled={BtonDisableEncuesta4}
          label="Continuar"
          color="primary"
          onClick={() => {
            enviarEncuesta2();
          }}
        ></ButtonZegel>
      </div>
    </>
  );

  const footerEncuestaDialog6 = (
    <>
      <div style={{ marginBottom: 8 }}>
        <ButtonZegel
          disabled={BtonDisableEncuesta6}
          label="Enviar y dirigirme a mi progreso"
          color="primary"
          onClick={() => {
            enviarEncuesta2();
          }}
        ></ButtonZegel>
      </div>
    </>
  );

  // pantalla dialog 1
  const encuestaCurso = (
    <div>
      <span>
        {/* <strong>¡Sigue así! Vas a la mitad del curso</strong> */}
        <strong>
          {cursoUsuario && cursoUsuario.idPrograma > 0
           ? "¡Sigue así! Vas a la mitad del módulo"
           : "¡Sigue así! Vas a la mitad del curso"}
            
          </strong>
      </span>
      <br></br>
      <span>
        <strong>{curso && curso.nombre}</strong>
      </span>
      <br></br>
      <br></br>
      <span>
        Queremos brindarte una buena experiencia dentro de la plataforma,
        ayúdanos respondiendo la siguiente pregunta.
      </span>
      <br></br>
      <br></br>
      <span>
        <strong>{"No te tomará más de 1 minuto. "}</strong>
        Muchas gracias.
      </span>
    </div>
  );

  const encuestaModulo = (
    <div>
      <span>
        <strong>¡Sigue así! Vas a la mitad del módulo</strong>
      </span>
      <br></br>
      <span>
        <strong>{curso && curso.nombre}</strong>
      </span>
      <br></br>
      <br></br>
      <span>
        Queremos brindarte una buena experiencia dentro de la plataforma,
        ayúdanos respondiendo la siguiente pregunta.
      </span>
      <br></br>
      <br></br>
      <span>
        <strong>{"No te tomará más de 1 minuto. "}</strong>
        Muchas gracias.
      </span>
    </div>
  );

  const handleButtonClickValoracionPlataforma = (buttonIndex) => {
    setBtonDisableEncuesta1(false);
    setSelectedButtonEncuetas1(buttonIndex);
  };

  // pantalla dialog 2
  const valoracionPlataforma = (
    <div>
      <p>
        <strong>Hasta el momento</strong>
      </p>
      <p>
        <strong>¿Qué tal te parece la navegación en la plataforma?</strong>
      </p>
      <div className="p-fluid formgrid grid mb-3 mt-3">
        <div className=" col-3 md:col-2  boton-evaluacion-plataforma">
          <button
            className={`boton ${selectedButtonEncuetas1 === 1
              ? "seleccionado boton-con-imagen"
              : "boton-con-imagen"
              }`}
            onClick={() => handleButtonClickValoracionPlataforma(1)}
          >
            <img src={Encuesta2} alt="" />
            <span style={{ fontSize: "12px" }}>Muy difícil</span>
          </button>
        </div>
        <div className=" col-3 md:col-2 boton-evaluacion-plataforma">
          <button
            className={`boton ${selectedButtonEncuetas1 === 2
              ? "seleccionado boton-con-imagen"
              : "boton-con-imagen"
              }`}
            onClick={() => handleButtonClickValoracionPlataforma(2)}
          >
            <img src={Encuesta3} alt="" />
            <span style={{ fontSize: "12px" }}>Difícil</span>
          </button>
        </div>
        <div className=" col-3 md:col-2 boton-evaluacion-plataforma">
          <button
            className={`boton ${selectedButtonEncuetas1 === 3
              ? "seleccionado boton-con-imagen"
              : "boton-con-imagen"
              }`}
            onClick={() => handleButtonClickValoracionPlataforma(3)}
          >
            <img src={Encuesta4} alt="" />
            <span style={{ fontSize: "12px" }}>Regular</span>
          </button>
        </div>
        <div className=" col-5 md:col-2 boton-evaluacion-plataforma-ml">
          <button
            className={`boton ${selectedButtonEncuetas1 === 4
              ? "seleccionado boton-con-imagen"
              : "boton-con-imagen"
              }`}
            onClick={() => handleButtonClickValoracionPlataforma(4)}
          >
            <img src={Encuesta1} alt="" />
            <span style={{ fontSize: "12px" }}>Fácil</span>
          </button>
        </div>
        <div className=" col-5 md:col-2 boton-evaluacion-plataforma-mr">
          <button
            className={`boton ${selectedButtonEncuetas1 === 5
              ? "seleccionado boton-con-imagen"
              : "boton-con-imagen"
              }`}
            onClick={() => handleButtonClickValoracionPlataforma(5)}
          >
            <img src={Encuesta5} alt="" />
            <span style={{ fontSize: "12px" }}>Muy fácil</span>
          </button>
        </div>
        <br></br>
      </div>

      <p style={{ textAlign: "initial" }} className="mb-3 pl-3">
        <strong >Cuéntanos tu experiencia (Opcional)</strong>
      </p>
      <div className="pl-3 pr-3">
        <InputTextarea
          placeholder="Escribe un comentario…"
          rows={5}
          cols={30}
          style={{ width: "100%" }}
          value={textareaEncuesta1Value}
          onChange={(e) => settextareaEncuesta1Value(e.target.value)}
        />
      </div>

    </div>
  );

  // pantalla dialog 3
  const encuestaCursoFinalizado = (
    <div>
      <span style={{ fontSize: "18px" }}>
        <strong>¡Felicitaciones {perfil && perfil.nombres}!</strong>
      </span>
      <br></br>
      <br></br>
      <span>
        Puedes descargar tu certificado del curso {curso && curso.nombre} en la
        sección “Mi progreso”.
      </span>
      <br></br>
      <br></br>
      <span>
        Queremos brindarte un excelente servicio educativo, ayúdanos
        respondiendo 3 preguntas.
        <strong>{" No te tomará más de 2 minutos. "}</strong>
      </span>
    </div>
  );

  const encuestaModuloFinalizado = (
    <div>
      <span style={{ fontSize: "18px" }}>
        <strong>¡Felicitaciones {perfil && perfil.nombres}!</strong>
      </span>
      <br></br>
      <br></br>
      <span>
        Puedes descargar tu certificado del módulo {curso && curso.nombre} en la
        sección “Mi progreso”.
      </span>
      <br></br>
      <br></br>
      <span>
        Queremos brindarte un excelente servicio educativo, ayúdanos
        respondiendo 3 preguntas.
        <strong>{" No te tomará más de 2 minutos. "}</strong>
      </span>
    </div>
  );

  const handleButtonClickEncuesta4 = (buttonIndex) => {
    setSelectedButtonEncuesta4(buttonIndex);
    setBtonDisableEncuesta4(false);
  };
  const firstRowNumbers = [0, 1, 2, 3, 4, 5];
  const secondRowNumbers = [6, 7, 8, 9, 10];
  // pantalla dialog 4
  const recomendacionCurso = (
    <>
      <div>
        <span>
          <strong>
          {cursoUsuario && cursoUsuario.idPrograma > 0
            ? "¿Recomendarías este curso?"
            : "¿Recomendarías este módulo?"}?</strong>
        </span>
        <br></br>
        <br></br>
        <span>Donde 0 es menos recomendable y 10 es muy recomendable.</span>
        <br></br>
        <br></br>
        <div className="botones-container-encuesta4">
          <div className="botones-row">
            {firstRowNumbers.map((number) => (
              <button
                key={number}
                className={`boton-encuesta4 ${selectedButtonEncuesta4 === number
                  ? "seleccionado-encuesta4"
                  : ""
                  }`}
                onClick={() => handleButtonClickEncuesta4(number)}
              >
                {number}
              </button>
            ))}
          </div>
          <div className="botones-row">
            {secondRowNumbers.map((number) => (
              <button
                key={number}
                className={`boton-encuesta4 ${selectedButtonEncuesta4 === number
                  ? "seleccionado-encuesta4"
                  : ""
                  }`}
                onClick={() => handleButtonClickEncuesta4(number)}
              >
                {number}
              </button>
            ))}
          </div>
        </div>
        <br></br>
      </div>
    </>
  );

  

  const handleButtonClickEncuetas5 = (buttonIndex) => {
    setBtonDisableEncuesta4(false);
    setSelectedButtonEncuetas5(buttonIndex);
  };
  // pantalla dialog 5
  const recomendacionCursoDialogo5 = (
    <>
      <div>
        <span>
          <strong>
          {cursoUsuario && cursoUsuario.idPrograma > 0
      ? "¿Sentiste que el contenido académico del módulo cumplió tus expectativas?"
      : "¿Sentiste que el contenido académico del curso cumplió tus expectativas?"}
            
          </strong>
        </span>
        <br></br>
        <br></br>
        <div className="p-fluid formgrid gridCurso
        ">
          <div className=" col-6 boton-evaluacion-plataformasi" >
            <button
              className={`boton ${selectedButtonEncuetas5 === 1
                ? "seleccionado boton-con-imagen"
                : "boton-con-imagen"
                }`}
              onClick={() => handleButtonClickEncuetas5(1)}
            >
              <img src={Encuesta5} alt="" />
              <span style={{ fontSize: "12px" }}>Sí</span>
            </button>
          </div>

          <div className=" col-6  boton-evaluacion-plataformano" >
            <button
              className={`boton ${selectedButtonEncuetas5 === 2
                ? "seleccionado boton-con-imagen"
                : "boton-con-imagen"
                }`}
              onClick={() => handleButtonClickEncuetas5(2)}
            >
              <img src={Encuesta4} alt="" />
              <span style={{ fontSize: "12px" }}>No</span>
            </button>
          </div>
        </div>
        <br></br>
      </div>
      <div style={{ textAlign: "initial" }}>
        <span>
          <strong>Cuéntanos por qué (Opcional)</strong>
        </span>
      </div>
      <br></br>
      <InputTextarea
        placeholder="Escribe un comentario…"
        rows={5}
        cols={30}
        style={{ width: "100%" }}
        value={textareaEncuesta5Value}
        onChange={(e) => settextareaEncuesta5Value(e.target.value)}
      />
    </>
  );
  const handleButtonClickEncuetas6 = (buttonIndex) => {
    setBtonDisableEncuesta6(false);
    setSelectedButtonEncuetas6(buttonIndex);
  };
  // pantalla dialog 6
  const recomendacionCursoDialogo6 = (
    <>
      <div>
        <span>
          <strong>
            ¿Sentiste que la calidad audiovisual aportó a tu aprendizaje?
          </strong>
        </span>
        <br></br>
        <br></br>
        <div className="p-fluid formgrid grid">

          <div className=" col-12 md:col-3 boton-evaluacion-plataforma">
            <button
              className={`boton ${selectedButtonEncuetas6 === 1
                ? "seleccionado boton-con-imagen"
                : "boton-con-imagen"
                }`}
              onClick={() => handleButtonClickEncuetas6(1)}
            >
              <img src={Encuesta5} alt="" />
              <span style={{ fontSize: "12px" }}>Sí</span>
            </button>
          </div>

          <div className=" col-12 md:col-3 boton-evaluacion-plataforma">
            <button
              className={`boton ${selectedButtonEncuetas6 === 2
                ? "seleccionado boton-con-imagen"
                : "boton-con-imagen"
                }`}
              onClick={() => handleButtonClickEncuetas6(2)}
            >
              <img src={Encuesta4} alt="" />
              <span style={{ fontSize: "12px" }}>No</span>
            </button>
          </div>
        </div>
        <br></br>
      </div>
      <div style={{ textAlign: "initial" }}>
        <span>
          <strong>Cuéntanos por qué (Opcional)</strong>
        </span>
      </div>
      <br></br>
      <InputTextarea
        placeholder="Escribe un comentario…"
        rows={5}
        cols={30}
        style={{ width: "100%" }}
        value={textareaEncuesta6Value}
        onChange={(e) => settextareaEncuesta6Value(e.target.value)}
      />
    </>
  );
  if (perfil === null) {
    return null;
  }
  // TOP

  const scrollDown = () => {
    document.getElementById("clickTopScroll").scroll(0, 0);
  };

  const playerConfig = {
    file: {
      attributes: {
        referrerpolicy: "strict-origin",
      },
    },
  };

  return (
    <>
      <div className="dashboard-cursoInterno  " ref={aboutSection}>
        <div>
          {          
          curso && (
            <div className="header-navBar">
              <div className="navBar-containerEvaluacionIntro">
                  <button
                    className="p-link-button button-img "
                    onClick={() => 
                      cursoUsuario && cursoUsuario.idPersonaPrograma !=null?
                      navigate("/" + PrivateRoutes.HOME + "/ProgresoPrograma/"+cursoUsuario.idPrograma+"/"+cursoUsuario.idPersonaPrograma+"/" + curso.idCurso):
                      /* navigate("/" + PrivateRoutes.HOME + "/ProgresoCurso/" + curso.idCurso): */
                      navigate("/" + PrivateRoutes.HOME + "/ProgresoCurso/" + curso.idCurso)
                      /* path={"ProgresoPrograma/:idPrograma/:idPersonaPrograma/:idCurso"}*/
                    }
                  > 
                    <i
                      className="pi pi-arrow-left"
                      style={{ fontSize: "1rem", fontWeight: "bold" }}
                    ></i>
                  </button>
              </div>
          </div>
          )}
        </div>

        <ProgressBar
          className="progressBar-interna"
          value={progresoBar + evaluacionesProgreso}
          displayValueTemplate={valueTemplate}
        ></ProgressBar>
        <div
          className="cursoInterno-content content-general-navigation"
          id="clickTopScroll"
        >
          {curso && (
            <>
              <div className="cursoInterno-content-desktop">
                <div className="flex align-items-center justify-content-between text-lg mb-3">
                  <div className="font-bold">{curso.nombre}</div>
                  <div className="font-bold">
                    {" "}
                    {unidadSeleccionada &&
                      `Unidad ${unidadSeleccionada.titulo}`}{" "}
                    {leccionSeleccionada.idLeccion > 0 &&
                      `- Lección ${leccionSeleccionada.secuencia}`}
                  </div>
                </div>
                <div className="flex gap-3 mb-5">
                  <div className="c-iterna-left">
                    {evaluacionSeleccionada ? (
                      <EvaluacionDashboard
                        cursoUsuario={cursoUsuario}
                        objUnidad={evaluacionSeleccionada}
                        evaluacionUnidad={evaluacionesUnidad}
                        personaCurso={idCursoUsuario}
                      />
                    ) : (
                      <>
                        <div className="c-interna-video">
                          <div className="c-interna-video-container">
                            {leccionSeleccionada.idLeccion > 0 && (
                              <ReactPlayer
                                url={
                                  "https://vimeo.com/" +
                                  leccionSeleccionada.urlVideo
                                }
                                width="100%"
                                height="100%"
                                controls={true}
                                referrerpolicy="strict-origin"
                                onProgress={handleProgress}
                                onDuration={handleDuration}
                                onPause={handlePause}
                              />
                            )}
                          </div>
                          <div className="c-interna-video-badge">
                            <p data-v-5903c47e="" className="title">
                              {leccionSeleccionada &&
                                leccionSeleccionada.titulo}
                            </p>
                            <p data-v-5903c47e="" className="brand-info ml-2">
                              ZEGEL | Escuela de Marketing
                            </p>
                          </div>
                        </div>

                        {materialesLeccion && (
                          <div className="c-interna-material mt-5">
                            <div className="interna-material-titulo font-bold text-lg">
                              Material Complementario
                            </div>
                            <div className="mt-3 w-full">
                              {materialesLeccion.map((item, i) => {
                                return (
                                  <div
                                    className="flex interna-material w-full mb-2"
                                    key={i}
                                  >
                                    <div className="interna-material-info">
                                      <div
                                        className="font-bold text-xs"
                                        style={{ marginBottom: 4 }}
                                      >
                                        Documento PDF
                                      </div>
                                      <div className="text-xs">
                                        {item.titulo}
                                      </div>
                                    </div>
                                    <a href={item.link} target="_blank">
                                      <div
                                        className=" flex align-items-center justify-content-center interna-material-download"
                                        style={{
                                          width: "77px",
                                          height: "100%",
                                        }}
                                      >
                                        <img
                                          src={iconDownload}
                                          width={"17.5px"}
                                          height={"21px"}
                                        ></img>
                                      </div>
                                    </a>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                        {/* {bibliografiaCurso?.length > 0 && (
                          <div className="c-interna-bibliografia mt-5">
                            <div className="interna-material-titulo font-bold text-lg">
                              Bibliografía general del curso
                            </div>
                            <div className="mt-3 w-full">
                              {bibliografiaCurso.map((item, i) => {
                                return (
                                  <div
                                    className="flex interna-material w-full mb-2"
                                    key={i}
                                  >
                                    <div className="interna-material-info">
                                      <div
                                        className="font-bold text-xs"
                                        style={{ marginBottom: 4 }}
                                      >
                                        Recomendación bibliográfica
                                      </div>
                                      <div className="text-xs">
                                        {item.nombre}
                                      </div>
                                    </div>
                                    <a href={item.linkZegel} target="_blank">
                                      <div
                                        className=" flex align-items-center justify-content-center interna-material-download"
                                        style={{
                                          width: "77px",
                                          height: "100%",
                                        }}
                                      >
                                        <img
                                          src={iconDownload}
                                          width={"17.5px"}
                                          height={"21px"}
                                        ></img>
                                      </div>
                                    </a>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )} */}
                        {/* <div className="">
                          <ButtonZegel label="Aprobar curso"></ButtonZegel>
                        </div> */}
                      </>
                    )}
                  </div>
                  <div className="c-iterna-right">
                    <div className="c-interna-unidades">
                      {listaUnidades && progresoCurso && (
                        <Accordion
                          /* activeIndex={findIndexById(parseInt(idUnidad))} */
                          activeIndex={findIndexById(parseInt(idUnidad===undefined?listaUnidades[0].idUnidad:idUnidad))}
                          expandIcon={
                            <i
                              className="icon-acordeon  pi pi-angle-down"
                              style={{ fontSize: "1rem" }}
                            ></i>
                          }
                          collapseIcon={
                            <i
                              className="icon-acordeon  pi pi-angle-up"
                              style={{ fontSize: "1rem" }}
                            ></i>
                          }
                          onTabOpen={(e) => {
                            setIndexTab(e.index);
                            setUnidadSeleccionada({ titulo: e.index + 1 });
                            setEvaluacionSeleccionada(null);
                          }}
                          onTabClose={() => {
                            setUnidadSeleccionada(null);
                            setLeccionSeleccionada({ idLeccion: 0 });
                            setEvaluacionSeleccionada(null);
                            setProgresoLeccionSeleccionado(null);
                            setCurrentTime(0);
                            setDuration(0);
                          }}
                        >
                          {listaUnidades &&
                            listaUnidades.map((item, i) => {
                              return (
                                <AccordionTab
                                  key={item.idUnidad}
                                  className="c-tab-interna"
                                  headerTemplate={() =>
                                    tabUnidadTemplate(
                                      i + 1,
                                      item.descripcion
                                    )
                                  }
                                >
                                  {listaLecciones &&
                                    listaLecciones
                                      .filter(
                                        (x) => x.idUnidad == item.idUnidad
                                      )
                                      .map((leccion, j) => {
                                        return (
                                          <div
                                            key={j}
                                            className={classNames(
                                              "tab-interna-leccion",
                                              {
                                                black:
                                                  leccion.idLeccion ===
                                                    leccionSeleccionada.idLeccion
                                                    ? true
                                                    : false,
                                              }
                                            )}
                                            onClick={() => {
                                              if (progresoCurso) {
                                                let progreso =
                                                  progresoCurso.find(
                                                    (x) =>
                                                      x.idLeccion ==
                                                      leccion.idLeccion
                                                  );
                                                if (progreso) {
                                                  setProgresoLeccionSeleccionado(
                                                    progreso
                                                  );
                                                }
                                              }

                                              guardarProgreso(
                                                leccionSeleccionada.idLeccion
                                              );
                                              setLeccionSeleccionada(leccion);
                                              setEvaluacionSeleccionada(null);
                                              setCurrentTime(0);
                                            }}
                                          >
                                            <div className="flex align-items-center internaLeccion-info">
                                              <div className="flex align-items-center internaLeccion-left">
                                                <i
                                                  className="pi pi-circle-fill"
                                                  style={{ fontSize: "5px" }}
                                                ></i>
                                              </div>
                                              <div
                                                className="text-xs internaLeccion-info-titulo pr-3"
                                                style={{ paddingLeft: 10 }}
                                              >
                                                <strong className="pr-3">
                                                  Lección {j + 1}
                                                </strong>
                                                {leccion.titulo}
                                              </div>
                                            </div>
                                            {EstadoLeccion(
                                              leccion.idLeccion
                                            ) && (
                                                <div className="flex align-items-center">
                                                  <i
                                                    className="pi pi-check"
                                                    style={{
                                                      fontSize: "9px",
                                                      fontWeight: "bold",
                                                    }}
                                                  ></i>
                                                </div>
                                              )}
                                          </div>
                                        );
                                      })}
                                  {listaLecciones && (
                                    <div
                                      className={classNames("", {
                                        "disabled-curso":
                                          (disabledCurso === true &&
                                            cursoUsuario.fechaAmpliacionCurso ==
                                            null) ||
                                          cursoExpiradoAmpliacion,
                                      })}
                                    >
                                      <div
                                        className="tab-interna-leccion evaluacion"
                                        onClick={() => {
                                          setEvaluacionSeleccionada(item);
                                          setLeccionSeleccionada({
                                            idLeccion: 0,
                                          });
                                        }}
                                      >
                                        <div className="flex align-items-center internaLeccion-info">
                                          <div className="flex align-items-center internaLeccion-left">
                                            <i
                                              className="pi pi-circle-fill"
                                              style={{ fontSize: "5px" }}
                                            ></i>
                                          </div>
                                          <div
                                            className="text-xs internaLeccion-info-titulo pr-3"
                                            style={{ paddingLeft: 10 }}
                                          >
                                            <strong className="pr-3">
                                              {((disabledCurso === true &&
                                                cursoUsuario.fechaAmpliacionCurso ==
                                                null) ||
                                                cursoExpiradoAmpliacion || cursoExpiradoMembresia) 
                                                ? cursoUsuario.idCondicion == 1? "Evaluación inactiva (Curso aprobado)":
                                                  cursoUsuario.idCondicion == 2? "Evaluación inactiva (Curso desaprobado)":
                                                   "Evaluación inactiva (Curso expirado)"
                                                : "Evaluación"}
                                            </strong>
                                          </div>
                                        </div>
                                      </div>
                                      {/* <div className="detalleEvaluacion">
                                        <div className="text-xs font-bold mb-2">
                                          Meta de aprendizaje
                                        </div>
                                        <div className="text-xs">
                                          ¿Qué esperas lograr con este curso?
                                        </div>
                                      </div> */}
                                    </div>
                                  )}
                                </AccordionTab>
                              );
                            })}
                        </Accordion>
                      )}
                    </div>
                    {/* <div className="detalleEvaluacion">
                      <div className="text-xs font-bold mb-2">
                        Meta de aprendizaje
                      </div>
                      <div className="text-xs">
                        {curso && curso.descripcionMeta}
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="cursoInterno-content-mobile">
                <div className="content-mobile-header">
                  <div className="text-lg mb-2 font-bold">{curso.nombre}</div>
                  <div className="text-xs font-bold">
                    {" "}
                    {unidadSeleccionada &&
                      `Unidad ${unidadSeleccionada.titulo}`}{" "}
                    {leccionSeleccionada.idLeccion > 0 &&
                      `- Lección ${leccionSeleccionada.secuencia}`}
                  </div>
                </div>
                {evaluacionSeleccionada ? (
                  <EvaluacionDashboard
                    cursoUsuario={cursoUsuario}
                    objUnidad={evaluacionSeleccionada}
                    evaluacionUnidad={evaluacionesUnidad}
                    personaCurso={idCursoUsuario}
                  />
                ) : (
                  <div className="c-interna-video">
                    <div className="c-interna-video-container">
                      {leccionSeleccionada.idLeccion > 0 && (
                        <ReactPlayer
                          url={
                            "https://vimeo.com/" + leccionSeleccionada.urlVideo
                          }
                          width="100%"
                          height="100%"
                          // style={{width: "100%",height: "100%"}}
                          controls={true}
                          onProgress={handleProgress}
                          onDuration={handleDuration}
                        />
                      )}
                    </div>
                    <div className="c-interna-video-badge">
                      <p data-v-5903c47e="" className="title">
                        {leccionSeleccionada && leccionSeleccionada.titulo}
                      </p>
                      <p data-v-5903c47e="" className="brand-info ml-2">
                        ZEGEL | Escuela de Marketing
                      </p>
                    </div>
                  </div>
                )}

                <div className="c-interna-avance">
                  <TabZal
                    cambiarAccion={() => { }}
                    indexDefault={parseInt(0)}
                    tipo="primary"
                    className="tab_zal_interna"
                    activeIndex={0}
                  >
                    <TabPanel header={`Avance`}>
                      <div className="c-interna-unidades ">
                        {listaUnidades && progresoCurso && (
                          <Accordion
                            activeIndex={findIndexById(parseInt(idUnidad===undefined?listaUnidades[0].idUnidad:idUnidad))}
                            expandIcon={
                              <i
                                className="icon-acordeon  pi pi-angle-down"
                                style={{ fontSize: "1rem" }}
                              ></i>
                            }
                            collapseIcon={
                              <i
                                className="icon-acordeon  pi pi-angle-up"
                                style={{ fontSize: "1rem" }}
                              ></i>
                            }
                            onTabOpen={(e) => {
                              setIndexTab(e.index);
                              setUnidadSeleccionada({ titulo: e.index + 1 });
                              setEvaluacionSeleccionada(null);
                            }}
                            onTabClose={() => {
                              setUnidadSeleccionada(null);
                              setLeccionSeleccionada({ idLeccion: 0 });
                              setProgresoLeccionSeleccionado(null);
                              setCurrentTime(0);
                              setDuration(0);
                              setEvaluacionSeleccionada(null);
                            }}
                          >
                            {listaUnidades &&
                              listaUnidades.map((item, i) => {
                                return (
                                  <AccordionTab
                                    key={item.idUnidad}
                                    className="c-tab-interna"
                                    headerTemplate={() =>
                                      tabUnidadTemplate(
                                        item.secuencia,
                                        item.descripcion
                                      )
                                    }
                                  >
                                    {listaLecciones &&
                                      listaLecciones
                                        .filter(
                                          (x) => x.idUnidad == item.idUnidad
                                        )
                                        .map((leccion, j) => {
                                          return (
                                            <div
                                              key={j}
                                              className={classNames(
                                                "tab-interna-leccion",
                                                {
                                                  black:
                                                    leccion.idLeccion ===
                                                      leccionSeleccionada.idLeccion
                                                      ? true
                                                      : false,
                                                }
                                              )}
                                              onClick={() => {
                                                if (progresoCurso) {
                                                  let progreso =
                                                    progresoCurso.find(
                                                      (x) =>
                                                        x.idLeccion ==
                                                        leccion.idLeccion
                                                    );
                                                  if (progreso) {
                                                    setProgresoLeccionSeleccionado(
                                                      progreso
                                                    );
                                                  }
                                                }

                                                guardarProgreso(
                                                  leccionSeleccionada.idLeccion
                                                );
                                                setLeccionSeleccionada(leccion);
                                                setEvaluacionSeleccionada(null);
                                                setCurrentTime(0);
                                                scrollDown();
                                              }}
                                            >
                                              <div
                                                className="flex align-items-center internaLeccion-info"
                                                onClick={() => scrollDown()}
                                              >
                                                <div className="flex align-items-center internaLeccion-left">
                                                  <i
                                                    className="pi pi-circle-fill"
                                                    style={{ fontSize: "5px" }}
                                                  ></i>
                                                </div>
                                                <div
                                                  className="text-xs internaLeccion-info-titulo pr-3"
                                                  style={{ paddingLeft: 10 }}
                                                  onClick={() => scrollDown()}
                                                >
                                                  <strong className="pr-3">
                                                    Lección {leccion.secuencia}
                                                  </strong>
                                                  {leccion.titulo}
                                                </div>
                                              </div>
                                              {EstadoLeccion(
                                                leccion.idLeccion
                                              ) && (
                                                  <div className="flex align-items-center">
                                                    <i
                                                      className="pi pi-check"
                                                      style={{
                                                        fontSize: "9px",
                                                        fontWeight: "bold",
                                                      }}
                                                    ></i>
                                                  </div>
                                                )}
                                            </div>
                                          );
                                        })}
                                    {listaLecciones && (
                                      <div
                                        className={classNames("", {
                                          "disabled-curso":
                                            disabledCurso === true,
                                        })}
                                      >
                                        <div
                                          className="tab-interna-leccion evaluacion"
                                          onClick={() => {
                                            setEvaluacionSeleccionada(item);
                                            setLeccionSeleccionada({
                                              idLeccion: 0,
                                            });
                                            scrollDown();
                                          }}
                                        >
                                          <div className="flex align-items-center internaLeccion-info">
                                            <div className="flex align-items-center internaLeccion-left">
                                              <i
                                                className="pi pi-circle-fill"
                                                style={{ fontSize: "5px" }}
                                              ></i>
                                            </div>
                                            <button
                                              className="text-xs internaLeccion-info-titulo pr-3 "
                                              style={{ paddingLeft: 10 }}
                                              onClick={() => scrollDown()}
                                            >
                                              <strong className="pr-3">
                                                {disabledCurso === true
                                                  ? cursoUsuario.idCondicion == 1? "Evaluación inactiva (Curso aprobado)":
                                                  cursoUsuario.idCondicion == 2? "Evaluación inactiva (Curso desaprobado)":
                                                  "Evaluación inactiva (Curso expirado)"
                                                  : "Evaluación"}
                                              </strong>
                                            </button>
                                          </div>
                                        </div>
                                        {/* <div className="detalleEvaluacion">
                                          <div className="text-xs font-bold mb-2">
                                            Meta de aprendizaje
                                          </div>
                                          <div className="text-xs">
                                            ¿Qué esperas lograr con este curso?
                                          </div>
                                        </div> */}
                                      </div>
                                    )}
                                  </AccordionTab>
                                );
                              })}
                          </Accordion>
                        )}
                      </div>
                      {/* <div className="detalleEvaluacion">
                        <div className="text-xs font-bold mb-2">
                          Meta de aprendizaje
                        </div>
                        <div className="text-xs">
                          {curso && curso.descripcionMeta}
                        </div>
                      </div> */}
                    </TabPanel>
                    <TabPanel header={`Material`}>
                      <div className="mt-3 w-full">
                        {materialesLeccion &&
                          materialesLeccion.map((item, i) => {
                            return (
                              <div
                                className="flex interna-material w-full mb-2"
                                key={i}
                              >
                                <div className="interna-material-info">
                                  <div
                                    className="font-bold text-xs"
                                    style={{ marginBottom: 4 }}
                                  >
                                    Documento PDF
                                  </div>
                                  <div className="text-xs">{item.titulo}</div>
                                </div>
                                <a href={item.link} target="_blank">
                                  <div
                                    className=" flex align-items-center justify-content-center interna-material-download"
                                    style={{ width: "77px", height: "100%" }}
                                  >
                                    <img
                                      src={iconDownload}
                                      width={"17.5px"}
                                      height={"21px"}
                                    ></img>
                                  </div>
                                </a>
                              </div>
                            );
                          })}
                      </div>
                    </TabPanel>
                  </TabZal>
                </div>
              </div>
            </>
          )}
          {/* <div className="chat"
            data-tenet-id="inlearning"
            data-session-name="Juan Garcia"
            data-session-email="mario.lema.ch@gmail.com"
            data-extra-codigo-curso="9999">
          </div> */}
        </div>
        <div className="dashboard-footer-curso-interno" height="29vh">
          <div className="footer-content">
            <div style={{ height: 16 }}>
              <p style={{ color: "#fff", fontSize: 12 }}>Con resplado de: </p>
            </div>
            <div className="flex align-items-center gap-4 mt-2">
              <img
                src={zegel}
                height={40} style={{ height: 40 }}
              ></img>
              {/* <img
            src="https://zegelvirtual.nyc3.cdn.digitaloceanspaces.com/assets/logosCorreo/zegelIpae.png"
            height={32} style={{ height: 32 }}
          ></img>  */}
              <img
                src="https://zegelvirtual.nyc3.cdn.digitaloceanspaces.com/assets/logosCorreo/logo_intercorp.png"
                height={20} style={{ height: 20 }}
              ></img>
            </div>
          </div>
        </div>
      </div>
      <DialogZegel
        header=""
        visible={showAlertEncuestaCurso}
        width="30vw"
        onHide={() => setShowAlertEncuestaCurso(false)}
        footer={footerEncuestaCurso}
        contenido={contenidoEncuestaCurso}
        textAlign="center"
      ></DialogZegel>
      <DialogZegel
        header=""
        visible={showAlertValoracionPlataforma}
        width="40vw"
        onHide={() => setShowAlertValoracionPlataforma(false)}
        footer={footerValoracionPlataforma}
        contenido={valoracionPlataforma}
        textAlign="left"
      ></DialogZegel>
      <DialogZegel
        header=""
        visible={showAlertRecomendacionCurso}
        width="30vw"
        onHide={() => setshowAlertRecomendacionCurso(false)}
        footer={footerRecomendacionPlataforma}
        contenido={recomendacionCurso}
        textAlign="left"
      ></DialogZegel>
      <DialogZegel
        header=""
        visible={showAlertRecomendacionCursoDialog5}
        width="30vw"
        onHide={() => setshowAlertRecomendacionCursoDialog5(false)}
        footer={footerRecomendacionPlataforma}
        contenido={recomendacionCursoDialogo5}
        textAlign="left"
      ></DialogZegel>
      <DialogZegel
        header=""
        visible={showAlertRecomendacionCursoDialog6}
        width="30vw"
        onHide={() => setshowAlertRecomendacionCursoDialog6(false)}
        footer={footerEncuestaDialog6}
        contenido={recomendacionCursoDialogo6}
        textAlign="left"
      ></DialogZegel>
  
    </>
  );
};

export default CursoInterno;
